import { render, staticRenderFns } from "./CommitteeDocumentReview.vue?vue&type=template&id=18e4e7c7&scoped=true"
import script from "./CommitteeDocumentReview.vue?vue&type=script&lang=js"
export * from "./CommitteeDocumentReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4e7c7",
  null
  
)

export default component.exports